import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=25f47a7c&scoped=true"
import script from "./MediaDetail.vue?vue&type=script&lang=js"
export * from "./MediaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f47a7c",
  null
  
)

export default component.exports